module.exports = __webpack_public_path__ + "img/rank_lance_corporal.f7f5bd76.svg";